// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
The app included on page: medical-personnel-military-first-responders-discount is not complicable with our theme. 
For that reason i am overwritting some of the classes inside the script
*/
.rte .rte__iframe {
  padding-bottom: 2465px !important;
}
@media (max-width: 1143px) {
  .rte .rte__iframe {
    padding-bottom: 4780px !important;
  }
}
@media (max-width: 885px) {
  .rte .rte__iframe {
    padding-bottom: 9600px !important;
  }
}
@media (max-width: 800px) {
  .rte .rte__iframe {
    padding-bottom: 9140px !important;
  }
}
@media (max-width: 700px) {
  .rte .rte__iframe {
    padding-bottom: 8585px !important;
  }
}
@media (max-width: 550px) {
  .rte .rte__iframe {
    padding-bottom: 7610px !important;
  }
}
@media (max-width: 450px) {
  .rte .rte__iframe {
    padding-bottom: 6935px !important;
  }
}
.rte .rte__iframe .rte__iframe iframe {
  position: relative !important;
  height: 1240px !important;
}
@media (max-width: 800px) {
  .rte .rte__iframe .rte__iframe iframe {
    height: 3280px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/medical-app.scss"],"names":[],"mappings":"AAAA;;;CAAA;AAME;EACE,iCAAA;AADJ;AAGI;EAHF;IAII,iCAAA;EAAJ;AACF;AAEI;EAPF;IAQI,iCAAA;EACJ;AACF;AACI;EAXF;IAYI,iCAAA;EAEJ;AACF;AAAI;EAfF;IAgBI,iCAAA;EAGJ;AACF;AADI;EAnBF;IAoBI,iCAAA;EAIJ;AACF;AAFI;EAvBF;IAwBI,iCAAA;EAKJ;AACF;AAHI;EACE,6BAAA;EACA,yBAAA;AAKN;AAHM;EAJF;IAKI,cAAA;EAMN;AACF","sourcesContent":["/*\nThe app included on page: medical-personnel-military-first-responders-discount is not complicable with our theme. \nFor that reason i am overwritting some of the classes inside the script\n*/\n\n.rte {\n  .rte__iframe {\n    padding-bottom: 2465px !important;\n\n    @media (max-width: 1143px) {\n      padding-bottom: 4780px !important;\n    }\n\n    @media (max-width: 885px) {\n      padding-bottom: 9600px !important;\n    }\n\n    @media (max-width: 800px) {\n      padding-bottom: 9140px !important;\n    }\n\n    @media (max-width: 700px) {\n      padding-bottom: 8585px !important;\n    }\n\n    @media (max-width: 550px) {\n      padding-bottom: 7610px !important;\n    }\n\n    @media (max-width: 450px) {\n      padding-bottom: 6935px !important;\n    }\n\n    .rte__iframe iframe {\n      position: relative !important;\n      height: 1240px !important;\n\n      @media (max-width: 800px) {\n        height: 3280px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
